import {
  BackendGiveawayAnswerToUpdate,
  toBackendGiveawayAnswerToUpdate,
} from '@/staff/secondary/club/giveaway/BackendGiveawayAnswerToUpdate';
import { GiveawayQuestionToUpdate } from '@/staff/domain/club/giveaway/GiveawayQuestionToUpdate';
import { BackendTranslation, toBackendTranslation } from '@/common/secondary/BackendTranslation';
import { GiveawayQuestionPreTitle } from '@/staff/domain/club/giveaway/GiveawayQuestionPreTitle';

export interface BackendGiveawayQuestionToUpdate {
  id?: string;
  answers: BackendGiveawayAnswerToUpdate[];
  required: boolean;
  rightAnswerText?: string;
  quizMode: boolean;
  multiline: boolean;
  titleTranslations: BackendTranslation[];
  preTitleTranslations?: BackendTranslation[];
}

export const toBackendGiveawayQuestionToUpdate = (giveawayQuestionToUpdate: GiveawayQuestionToUpdate): BackendGiveawayQuestionToUpdate => ({
  id: giveawayQuestionToUpdate.id.orElseUndefined(),
  answers: giveawayQuestionToUpdate.answers.map(toBackendGiveawayAnswerToUpdate),
  required: giveawayQuestionToUpdate.required,
  rightAnswerText: giveawayQuestionToUpdate.rightAnswer.map(rightAnswer => rightAnswer.textTranslations[0].value).orElseUndefined(),
  quizMode: giveawayQuestionToUpdate.quizMode,
  multiline: giveawayQuestionToUpdate.multiline,
  titleTranslations: giveawayQuestionToUpdate.titleTranslations.map(toBackendTranslation),
  preTitleTranslations: giveawayQuestionToUpdate.preTitleTranslations
    .map(translations => translations.map(toBackendTranslation<GiveawayQuestionPreTitle>))
    .orElseUndefined(),
});
